function LandingFounder () {
  return (
    <section className='lp-founder-section'>
      <div className='lp-section-content'>
        <div className='lp-founder-content'>
          <div className='lp-founder-text'>
            <h2 className='lp-founder-title'>
              Von Servicetechnikern, für Servicetechniker
            </h2>
            <p className='lp-founder-quote'>
              "Als Field Service Engineer bin ich täglich mit denselben
              Herausforderungen konfrontiert: Stundenlange Suche in
              Service-Manuals, ständige Rückfragen bei Kollegen, und das
              Gefühl, dass wichtiges Wissen verloren geht. Was früher Stunden
              dauerte, sollte Minuten dauern.
            </p>
            <p className='lp-founder-quote'>
              Deshalb habe ich EngKnowledge entwickelt - eine Plattform, die
              technisches Wissen nicht länger im Kopf einzelner Mitarbeiter
              verliert, sondern für Teams zugänglich und nutzbar macht."
            </p>
            <div className='lp-founder-signature'>
              <strong>Xaver</strong>
              <span className='lp-founder-role'>
                Gründer & Field Service Engineer bei Asclepion Laser Technologies
              </span>
            </div>
          </div>
          <div className='lp-founder-image'>
            <img
              src='/founder-photo.jpg'
              alt='Xaver - Gründer von EngKnowledge'
              className='lp-founder-photo'
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default LandingFounder

